import { useNavigate } from "react-router-dom";
import { Menu, User as UserIcon, LifeBuoy, Mail, CreditCard, LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { label: "Profilo", to: "/profile", icon: UserIcon, testid: "mobile-menu-profile" },
  { label: "Assistenza", to: "/assistenza", icon: LifeBuoy, testid: "mobile-menu-help" },
  { label: "Contatti", to: "/contatti", icon: Mail, testid: "mobile-menu-contact" },
  { label: "Abbonamento", to: "/profile#abbonamento", icon: CreditCard, testid: "mobile-menu-subscription" },
];

const itemCls = "min-h-[44px] gap-3 px-3 text-base font-sans text-[var(--fg-1)] cursor-pointer";

export const MobileAccountMenu = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="mobile-menu-trigger"
          aria-label="Apri menu account"
          className="md:hidden h-11 w-11 rounded-full hover:bg-[var(--bg-3)] flex items-center justify-center text-[var(--fg-1)]"
          style={{ transition: "background-color 0.2s ease" }}
        >
          <Menu size={22} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        data-testid="mobile-menu-content"
        className="md:hidden w-56 rounded-xl border-[var(--border-c)] bg-[var(--bg-1)] p-1.5"
      >
        {ITEMS.map(({ label, to, icon: Icon, testid }) => (
          <DropdownMenuItem key={testid} data-testid={testid} className={itemCls} onSelect={() => navigate(to)}>
            <Icon size={18} className="text-[var(--fg-2)]" />
            {label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator className="bg-[var(--border-c)]" />
        <DropdownMenuItem data-testid="mobile-menu-logout" className={`${itemCls} text-red-600 focus:text-red-600`} onSelect={logout}>
          <LogOut size={18} />
          Esci dall'account
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MobileAccountMenu;
